import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const SpotifyAddSongsPrompt = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  const spotifyPlaylistUrl =
    "https://open.spotify.com/playlist/5OEaQO9thajo9fVgJgqxFo?si=2d97d8906a3d4ace&pt=3e12983155268197524ebe628de903e5";

  if (!visible) return null;

  return (
    <>
      <style>{`
        .spotify-prompt {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 140px;
          height: 140px;
          background-color: #1DB954;
          color: white;
          border-radius: 12px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          font-weight: bold;
          font-size: 16px;
          cursor: pointer;
          padding: 20px;
          user-select: none;
          z-index: 9999;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          text-decoration: none;
          text-align: center;
          transition: background-color 0.3s ease;
          position: fixed;
        }
        .spotify-prompt:hover {
          background-color: #17b84e;
        }
        .spotify-icon {
          width: 48px;
          height: 48px;
          flex-shrink: 0;
        }
        .close-btn {
          position: absolute;
          top: 6px;
          right: 8px;
          color: white;
          background: transparent;
          border: none;
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          user-select: none;
          line-height: 1;
          padding: 0;
        }
        .close-btn:hover {
          color: #000000cc;
        }
        /* Mobile: horizontal layout, full width bar */
        @media (max-width: 600px) {
          .spotify-prompt {
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            height: 60px;
            border-radius: 0;
            font-size: 18px;
            flex-direction: row;
            padding: 0 20px;
            gap: 12px;
            text-align: left;
            justify-content: center;
          }
          .spotify-icon {
            width: 32px;
            height: 32px;
          }
          .close-btn {
            top: 10px;
            right: 12px;
            font-size: 24px;
          }
        }
      `}</style>

      <a
        href={spotifyPlaylistUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="spotify-prompt"
        title="Add your 90s songs to the party playlist!"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-btn"
          aria-label="Close Spotify prompt"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setVisible(false);
          }}
        >
          &times;
        </button>
        <svg
          className="spotify-icon"
          role="img"
          viewBox="0 0 168 168"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          <circle fill="#1ED760" cx="84" cy="84" r="84" />
          <path
            fill="#fff"
            d="M119.7 117.7c-1.5 2.2-4.7 2.8-6.9 1.3-19-13-43-15.9-70.8-8-2.7.7-5.5-1-6.2-3.7-.7-2.7 1-5.5 3.7-6.2 30.3-8 57.3-4.6 78.4 9.1 2.2 1.5 2.8 4.7 1.3 6.9zm9.9-21.5c-1.8 2.7-5.4 3.5-8.1 1.7-21.7-14-54.8-18.1-80.5-9-3.2 1-6.7-1-7.7-4.2-1-3.2 1-6.7 4.2-7.7 29.8-9.6 67-4.9 92.1 10.3 2.7 1.8 3.5 5.4 1.7 8.1zm2.5-22.3C106.3 53.3 66 49.2 37.7 58.6c-3.7 1.2-7.7-1-8.9-4.7-1.2-3.7 1-7.7 4.7-8.9 33.2-11 79.8-6.4 109.8 12.2 3.3 1.9 4.5 6.4 2.6 9.7-1.9 3.3-6.4 4.5-9.7 2.6z"
          />
        </svg>
        {t("spotifyPrompt")}
      </a>
    </>
  );
};

export default SpotifyAddSongsPrompt;
